webshop.ProductList = class {
	/* Options:
		- items: Items
		- settings: Webshop Settings
		- products_section: Products Wrapper
		- preference: If preference is not list view, render but hide
	*/
	constructor(options) {
		Object.assign(this, options);

		if (this.preference !== "List View") {
			this.products_section.addClass("hidden");
		}

		// Load-more (PIT-TASK-2027-000135): appended batches must extend the
		// list instead of replacing it.
		if (!this.append_mode) {
			this.products_section.empty();
		}

		this.make();
	}

	make() {
		let me = this;
		let html = ``;

		this.items.forEach(item => {
			let title = item.web_item_name || item.item_name || item.item_code || "";
			title =  title.length > 90 ? title.substr(0, 90) + "..." : title;

			html += `<div class="row list-row w-100">`;
			html += me.get_image_html(item, title);
			html += me.get_item_details_section(item, title, me.settings);
			html += `</div>`;

		});

		let $product_wrapper = this.products_section;
		$product_wrapper.append(html);

		this.bind_qty_events();
	}

	bind_qty_events() {
		// Load-more (PIT-TASK-2027-000135): rebind safely with namespaced
		// delegated handlers on each append.
		this.products_section.off("input.wsQty click.wsQty");
		this.products_section.on("input.wsQty", ".item-qty-area .item-qty", (event) => {
			let currentValue = event.target.value;
			let validValue = currentValue.replace(/[^0-9]/g, "");
			event.target.value = validValue;
		});

		this.products_section.on("click.wsQty", ".item-qty-area .up-qty", (event) => {
			let item_qty = $(event.target).closest(".item-qty-area").find(".item-qty");
			let step = parseInt(item_qty.data("lot-size")) || 1;
			let currentValue = parseInt(item_qty.val()) || 0;
			item_qty.val(currentValue + step);
		});

		this.products_section.on("click.wsQty", ".item-qty-area .dwn-qty", (event) => {
			let item_qty = $(event.target).closest(".item-qty-area").find(".item-qty");
			let step = parseInt(item_qty.data("lot-size")) || 1;
			let minQty = parseInt(item_qty.data("min-qty")) || 1;
			let currentValue = parseInt(item_qty.val()) || 0;
			item_qty.val(Math.max(currentValue - step, minQty));
		});
	}

	get_image_html(item, title) {
		let image = item.website_image;
		const ratio_class = webshop.get_image_ratio_class ? webshop.get_image_ratio_class(this.settings) : "";
		const badge_html = webshop.get_new_badge_html ? webshop.get_new_badge_html(item) : "";
		const discount_badge_html = webshop.get_discount_badge_html ? webshop.get_discount_badge_html(item) : "";
		// Detail page toggle (PIT-TASK-2027-000166): no link when disabled
		const item_link = webshop.get_item_link ? webshop.get_item_link(item, this.settings) : `/${ item.route || '#' }`;

		if (image) {
			const img_html = `<img itemprop="image" class="card-img" src="${ image }" alt="${ title }"
					loading="lazy">`;
			return `
				<div class="col-3 list-image${ ratio_class }">
					${ badge_html }
					${ discount_badge_html }
					${ item_link
						? `<a href="${ item_link }" style="text-decoration: none;">${ img_html }</a>`
						: img_html }
				</div>
			`;
		} else {
			const no_image_html = `<div class="card-img-top no-image">${ frappe.get_abbr(title) }</div>`;
			return `
				<div class="col-3 list-image${ ratio_class }">
					${ badge_html }
					${ discount_badge_html }
					${ item_link
						? `<a href="${ item_link }" style="text-decoration: none;">${ no_image_html }</a>`
						: no_image_html }
				</div>
			`;
		}
	}

	get_item_details_section(item, title, settings) {
		let details = `
			<div class="col-9 text-left list-item-details">
				<div class="row">
					<div class="col-8">
		`;
		details += this.get_title_html(item, title, settings);
		details += this.get_item_details(item, settings);
		details += `
					</div>
					<div class="col-4 list-qty-col">
		`;
		// Wishlist icon (right column, below the qty controls)
		const wish_html = (!item.has_variants && settings.enable_wishlist)
			? this.get_wishlist_icon(item) : '';
		details += wish_html;
		details += `
					</div>
				</div>
		`;
		details += this.get_bottom_row_html(item, settings);
		details += `</div>`;
		return details;
	}

	// Short description + cart controls in one bottom row (PIT-TASK-2027-000141
	// adjustment): description on the left, qty + add-to-cart on the right,
	// pinned to the bottom of the row body (margin-top: auto via CSS).
	get_bottom_row_html(item, settings) {
		const cart_row = this.get_cart_action_row(item, settings);
		const desc = item.short_description
			? `<div class="ws-short-desc">${ item.short_description }</div>` : ``;
		if (!desc && !cart_row) return ``;
		return `<div class="ws-bottom-row">${ desc }${ cart_row }</div>`;
	}

	get_title_html(item, title, settings) {
		// Detail page toggle (PIT-TASK-2027-000166): no link when disabled
		const item_link = webshop.get_item_link ? webshop.get_item_link(item, settings) : `/${ item.route || '#' }`;
		const title_html = item_link
			? `<a href="${ item_link }"
					style="color: var(--gray-800); font-weight: 600; text-decoration: none;">
					${ title }
				</a>`
			: `<span style="color: var(--gray-800); font-weight: 600;">${ title }</span>`;
		return `
			<div style="display: flex; align-items: center;">
				<div style="flex: 1;">
					${ settings.custom_show_item_code ? `<div class="product-code-plain">${ item.item_code || '' }</div>` : '' }
					${ title_html }
				</div>
			</div>
		`;
	}

	get_item_details(item, settings) {
		let details = '';
		if (settings.custom_show_item_group) {
			details += `
			<div class="product-category" itemprop="name">
				${ item.item_group_display || item.item_group }
			</div>
		`;
		}

		// Standard price display: the bulk list no longer contains the regular
		// price row (PIT-TASK-2027-000163 follow-up), so .product-price is the
		// single source of the Einzelpreis — render it whenever a price exists.
		if (item.formatted_price) {
			details += `
				<div class="product-price" itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer">
					${ item.formatted_price || '' }
			`;

			if (item.formatted_mrp) {
				details += `
				<small class="striked-price">
					<s>${ item.formatted_mrp ? item.formatted_mrp.replace(/ +/g, "") : "" }</s>
				</small>
			`;
			}

			details += this.get_stock_availability(item, settings);
			details += `</div>`;
		} else {
			details += this.get_stock_availability(item, settings);
		}

		return details;
	}

	get_stock_availability(item, settings) {
		// "Sofort lieferbar" (PIT-TASK-2027-000280) on in-stock items —
		// mirrors the detail page's dispatcher line, independent of
		// show_stock_availability.
		if (!item.has_variants && item.is_stock && item.in_stock && !item.delivery_on_request) {
			return `
				<br>
				<span class="in-stock in-green has-stock mt-2"
					style="font-size: 14px;">${ __("Currently available") }</span>
			`;
		}
		if (settings.show_stock_availability && !item.has_variants) {
			if (item.on_backorder) {
				return `
				<br>
				<span class="out-of-stock mt-2" style="color: var(--primary-color)">
					${ __("Available on backorder") }
				</span>
			`;
			} else if (!item.in_stock) {
				return `
				<br>
				<span class="out-of-stock mt-2">${ __("Out of stock") }</span>
			`;
			}
		}
		return ``;
	}

	get_wishlist_icon(item) {
		let icon_class = item.wished ? "wished" : "not-wished";

		return `

		<div class="like-action-list ${ item.wished ? "like-action-wished" : '' }" data-item-code="${ item.item_code }">
			<svg class="icon sm">
				<use class="${ icon_class } wish-icon" href="#icon-heart"></use>
			</svg>
		</div>`;
	}

	get_cart_action_row(item, settings) {
		if (item.has_variants) {
			// Variants can only be chosen on the detail page — without it,
			// the Explore button has no target (PIT-TASK-2027-000166).
			if (webshop.detail_page_enabled && !webshop.detail_page_enabled(settings)) {
				return ``;
			}
			return `
				<div class="mt-3">
					<a href="/${ item.route || '#' }">
						<div class="btn btn-sm btn-explore-variants btn-cart-action">
							${ __("Explore") }
						</div>
					</a>
				</div>
			`;
		}

		if (!settings.enabled || (!settings.allow_items_not_in_stock && !item.in_stock)) {
			return ``;
		}

		// "Liefertermin auf Anfrage" (PIT-TASK-2027-000219 Adjust 2): no
		// stock and no open PO — cannot be added to the cart.
		if (item.delivery_on_request) {
			return `
				<div class="cart-action-row mt-3">
					<span class="text-muted font-sm">${ __("Delivery date on request") }</span>
				</div>
			`;
		}

		return `
			<div class="cart-action-row mt-3">
				<div class="item-qty-area">
					<div class="input-group number-spinner">
						<span class="input-group-prepend d-sm-inline-block">
							<button class="item-qty-btn dwn-qty" data-dir="dwn">
								&ndash;
							</button>
						</span>
						<input class="form-control text-center item-qty"
							value="${ item.min_qty || 1 }"
							min="${ item.min_qty || 1 }"
							step="${ item.lot_size || 1 }"
							data-item-code="${ item.item_code }"
							data-min-qty="${ item.min_qty || 1 }"
							data-lot-size="${ item.lot_size || 1 }">
						<span class="input-group-append d-sm-inline-block">
							<button class="item-qty-btn up-qty" data-dir="up">
								+
							</button>
						</span>
					</div>
				</div>
				<div id="${ item.name }" class="btn btn-sm btn-primary btn-add-to-cart-list"
					data-item-code="${ item.item_code }"
					title="${ settings.enable_checkout ? __("Add to Cart") : __("Add to Quote") }">
					<svg class="icon icon-md" viewBox="0 0 24 24" fill="none">
						<path d="M3 6h17" stroke="currentColor" stroke-miterlimit="10"></path>
						<path d="M20 19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6l3.4-3h10.2L20 6v13z" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"></path>
						<path d="M15.582 10c0 2.29-1.8 4.09-4.091 4.09A4.051 4.051 0 0 1 7.4 10" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
						<circle cx="15.6" cy="10" r=".5" stroke="currentColor"></circle>
						<circle cx="7.3" cy="10" r=".5" stroke="currentColor"></circle>
					</svg>
					${ item.in_cart ? `<span class="ws-cart-count-badge" data-item-code="${ item.item_code }">${ item.in_cart_qty }</span>` : '' }
				</div>
			</div>
		`;
	}
};
